interface SubmitButtonProps {
  isProcessing: boolean;
}

export function SubmitButton({ isProcessing }: SubmitButtonProps) {
  return (
    <button
      type="submit"
      disabled={isProcessing}
      className="btn btn-lg w-100 py-3 fw-semibold border-0 rounded-3"
      style={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.5)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 4px 15px rgba(102, 126, 234, 0.4)";
      }}
    >
      {isProcessing ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status">
            <span className="visually-hidden">Loading...</span>
          </span>
          Processing Payment...
        </>
      ) : (
        <>Pay Now</>
      )}
    </button>
  );
}
